import { useField, useFormikContext } from 'formik';
import { isEmpty } from 'lodash';
import { FC, useEffect, useState } from 'react';
import { FormikOption } from 'src/general/components/forms/FormikInput/FormikInput.types';
import { ToggleButtons } from 'src/general/components/ToggleButtons/ToggleButtons';
import { PlpFiltersRange } from './PlpFiltersRange';
import styles from './PlpFiltersRange.module.scss';

type PricingMode = 'cash' | 'finance';

interface Props {
  optionsCash: FormikOption[];
  optionsFinance: FormikOption[];
}

const toggleOptions: { mode: PricingMode; label: string }[] = [
  { mode: 'cash', label: 'Cash' },
  { mode: 'finance', label: 'Finance' },
];

export const PlpFiltersRangePrice: FC<Props> = ({ optionsCash, optionsFinance }) => {
  const [pricingMode, setPricingMode] = useState<PricingMode>('cash');
  const { setFieldValue } = useFormikContext();
  const [priceCashMinField] = useField('priceCashMin');
  const [priceCashMaxField] = useField('priceCashMax');
  const [priceFinMinField] = useField('priceFinMin');
  const [priceFinMaxField] = useField('priceFinMax');

  useEffect(() => {
    if (!isEmpty(priceCashMinField.value) || !isEmpty(priceCashMaxField.value)) {
      setPricingMode('cash');
      setFieldValue('priceFinMin', '');
      setFieldValue('priceFinMax', '');
    }
  }, [priceCashMinField.value, priceCashMaxField.value, setFieldValue]);

  useEffect(() => {
    if (!isEmpty(priceFinMinField.value) || !isEmpty(priceFinMaxField.value)) {
      setPricingMode('finance');
      setFieldValue('priceCashMin', '');
      setFieldValue('priceCashMax', '');
    }
  }, [priceFinMinField.value, priceFinMaxField.value, setFieldValue]);

  return (
    <div className={styles.priceRoot}>
      <div className={styles.rangeToggleContainer}>
        <ToggleButtons
          fullWidth
          toggleButtonsOptions={toggleOptions.map((item) => ({ value: item.mode, label: item.label }))}
          selectedValue={pricingMode}
          onToggle={(val) => {
            setPricingMode(val as PricingMode);
          }}
          variant="squared"
        />
      </div>
      {pricingMode === 'cash' && (
        <PlpFiltersRange
          minName="priceCashMin"
          maxName="priceCashMax"
          options={optionsCash}
          minPlaceholder="Min price"
          maxPlaceholder="Max price"
        />
      )}
      {pricingMode === 'finance' && (
        <PlpFiltersRange
          minName="priceFinMin"
          maxName="priceFinMax"
          options={optionsFinance}
          minPlaceholder="Min repayment"
          maxPlaceholder="Max repayment"
        />
      )}
    </div>
  );
};
